"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoCarouselSlide = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _PhotoCarouselSlide = require("./PhotoCarouselSlide.styles");
var _excluded = ["shouldAnimateTranslations", "slidePosition", "children"];
/**
 * Displays an individual item in a Photo Carousel.
 *
 * Renders up to three items: the item being displayed, the previous item and the next item.
 *
 * @since 8.66.0
 */

var PhotoCarouselSlide = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var shouldAnimateTranslations = _ref.shouldAnimateTranslations,
    slidePosition = _ref.slidePosition,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_PhotoCarouselSlide.StyledPhotoCarouselSlide, (0, _extends2.default)({
    "aria-hidden": slidePosition !== _constants.PHOTO_CAROUSEL_SLIDE_POSITIONS.CENTER,
    ref: forwardedRef,
    shouldAnimateTranslations: shouldAnimateTranslations,
    slidePosition: slidePosition
  }, rest), children);
});
exports.PhotoCarouselSlide = PhotoCarouselSlide;
PhotoCarouselSlide.displayName = 'PhotoCarouselSlide';
PhotoCarouselSlide.propTypes = {
  /**
   * The content to display inside of the slide.
   */
  children: _propTypes.default.node,
  /**
   * If true, the sliding animation is enabled.
   */
  shouldAnimateTranslations: _propTypes.default.bool,
  /**
   * Photo Carousel only renders up to three slides at a time. This prop dictates
   * where this slide is located. The center slide is the one currently visible.
   */
  slidePosition: _propTypes.default.oneOf(Object.values(_constants.PHOTO_CAROUSEL_SLIDE_POSITIONS)).isRequired
};
PhotoCarouselSlide.defaultProps = {
  shouldAnimateTranslations: true
};